(function () {
  function initTestimonialSection(section) {
    if (!section) return;

    const wrapper = section.querySelector(".flat-thumbnails-testimonial");
    if (!wrapper) return;

    const thumbEl = wrapper.querySelector(".tf-thumb-tes");
    const mainEl = wrapper.querySelector(".tf-tes-main");

    if (!thumbEl || !mainEl) return;

    if (thumbEl.swiper) thumbEl.swiper.destroy(true, true);
    if (mainEl.swiper) mainEl.swiper.destroy(true, true);

    const nextThumb = wrapper.querySelector(".nav-next-tes-thumb");
    const prevThumb = wrapper.querySelector(".nav-prev-tes-thumb");
    const paginationThumb = wrapper.querySelector(".sw-pagination-tes-thumb");

    const nextMain = wrapper.querySelector(".nav-next-tes-main");
    const prevMain = wrapper.querySelector(".nav-prev-tes-main");
    const paginationMain = wrapper.querySelector(".sw-pagination-tes-main");

    const spaceThumbLg = parseInt(thumbEl.dataset.spaceLg, 10) || 0;
    const spaceThumb = parseInt(thumbEl.dataset.space, 10) || 0;
    const spaceTesLg = parseInt(mainEl.dataset.spaceLg, 10) || 0;
    const spaceTes = parseInt(mainEl.dataset.space, 10) || 0;
    const effect = wrapper.dataset.effect || "slide";

    const swThumb = new Swiper(thumbEl, {
      speed: 800,
      spaceBetween: spaceThumb,
      effect: effect,
      fadeEffect: effect === "fade" ? { crossFade: true } : undefined,
      navigation: {
        nextEl: nextThumb,
        prevEl: prevThumb,
      },
      pagination: paginationThumb
        ? {
          el: paginationThumb,
          clickable: true,
        }
        : false,
      breakpoints: {
        768: {
          spaceBetween: spaceThumbLg,
        },
      },
      slideToClickedSlide: true,
      watchSlidesProgress: true,
    });

    const swMain = new Swiper(mainEl, {
      speed: 800,
      spaceBetween: spaceTes,
      effect: effect,
      fadeEffect: effect === "fade" ? { crossFade: true } : undefined,
      navigation: {
        nextEl: nextMain,
        prevEl: prevMain,
      },
      pagination: paginationMain
        ? {
          el: paginationMain,
          clickable: true,
        }
        : false,
      breakpoints: {
        768: {
          spaceBetween: spaceTesLg,
        },
      },
      autoHeight: effect === "fade",
    });

    swThumb.controller.control = swMain;
    swMain.controller.control = swThumb;

    section._testimonialThumbSwiper = swThumb;
    section._testimonialMainSwiper = swMain;

    // Click slide -> sync editor block focus
    if (window.Shopify && Shopify.designMode) {
      const allSlides = wrapper.querySelectorAll(".swiper-slide[data-block-id]");

      allSlides.forEach((slide, index) => {
        slide.addEventListener("click", function () {
          swThumb.slideTo(index);
          swMain.slideTo(index);
        });
      });
    }
  }

  function initAllTestimonialSections(scope = document) {
    const sections = scope.querySelectorAll('[id^="shopify-section-"]');
    sections.forEach((section) => {
      if (section.querySelector(".flat-thumbnails-testimonial")) {
        initTestimonialSection(section);
      }
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initAllTestimonialSections(document);
  });

  document.addEventListener("shopify:section:load", function (event) {
    initTestimonialSection(event.target);
  });

  document.addEventListener("shopify:section:reorder", function (event) {
    initTestimonialSection(event.target);
  });

  document.addEventListener("shopify:block:select", function (event) {
    const blockId = event.target && event.target.dataset ? event.target.dataset.blockId : null;
    if (!blockId) return;

    const section = event.target.closest('[id^="shopify-section-"]');
    if (!section) return;

    const swThumb = section._testimonialThumbSwiper;
    const swMain = section._testimonialMainSwiper;

    if (!swThumb || !swMain) return;

    const thumbSlides = Array.from(section.querySelectorAll(".tf-thumb-tes .swiper-slide[data-block-id]"));
    const mainSlides = Array.from(section.querySelectorAll(".tf-tes-main .swiper-slide[data-block-id]"));

    let index = thumbSlides.findIndex((slide) => slide.dataset.blockId === blockId);

    if (index < 0) {
      index = mainSlides.findIndex((slide) => slide.dataset.blockId === blockId);
    }

    if (index < 0) return;

    swThumb.slideTo(index);
    swMain.slideTo(index);
  });
})();